export default __webpack_public_path__ + "static/media/saoPauloHouseBranco.153883dc.png";